import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Layout, Title } from 'common/components/layout';

const ResetPasswordLinkError = (props) => {
  const { settings } = props;
  if (!settings.data) {
    return (
      <Layout title="Reset Password Error" loading>
        <Title>Reset Password Error</Title>
      </Layout>
    );
  }
  return (
    <Layout title="Reset Password Error">
      <Title>Reset Password Error</Title>
      Your link has expired. Links only remain valid for 4hrs. Please use the{' '}
      <Link to="/profile/forgot-password">forgot password</Link> to send a new
      link.
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(ResetPasswordLinkError);
